"use strict";

exports.__esModule = true;
exports["default"] = CircleMinus;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CircleMinus(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.004.063C7.214.063.063 7.215.063 16.001c0 8.79 7.152 15.936 15.941 15.936 8.79 0 15.934-7.146 15.934-15.936 0-8.786-7.144-15.938-15.934-15.938zm7.976 18.1H8.015a2.162 2.162 0 0 1-2.159-2.16c0-1.198.969-2.171 2.159-2.171H23.98c1.194 0 2.167.971 2.167 2.161a2.171 2.171 0 0 1-2.167 2.169z"
  }));
}